import { GraphQLClient } from "graphql-request";
import { getSdk } from "../interfaces";

const client = new GraphQLClient(process.env.NEXT_PUBLIC_GRAPHCMS_ENDPOINT!);
const sdkReadOnly = getSdk(client);

export default sdkReadOnly;
